import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, isEmpty } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { User, Roles } from '../../core/authentication/user';
import { Search } from 'src/app/core/Search/Search';
import { formatDate } from '@angular/common';
import { url } from '../../shared/urls/url';
import { environment } from 'src/environments/environment';

@Injectable()

export class AuthenticationService {
  firebaseAuht = firebase.initializeApp(environment.firebase);
  user: Observable<User>;
  userprofile: User;
  public Token: string;

  httpOptions = {
    headers: new HttpHeaders({ Authorization: 'Bearer ' + localStorage.getItem('TokenServe') })
  };

  //URLString = 'http://localhost:50810';
  constructor(
    private url: url,
    private http: HttpClient,
  ) { }

  loginGoogle() {
    return this.firebaseAuht.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(function (result) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      var token = result.credential;
      console.log(token);
      // The signed-in user info.
      var user = result.user;
      console.log(user);
      // ...
    }).catch(function (error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
    });;
  }

  registerUser(userRegister: User, pass: string) {

    return new Promise((resolve, reject) => {

      this.firebaseAuht.auth().createUserWithEmailAndPassword(userRegister.email, pass)
        .then(userData => {
          userRegister.uid = userData.user.uid;
          this.loginserver(userData.user.uid);
          localStorage.setItem('uid', userData.user.uid);

          userData.user.getIdToken(true).then(token => {
            localStorage.setItem('token', token);
            // this.loginserver(token).subscribe((data: any) => console.log('retorno' + data), error => console.log(error.message));

          });
          localStorage.setItem('uidCreat', userData.user.uid);
          localStorage.setItem('language', 'es');
          this.RecordUserData(userRegister);

          resolve(userData.user.uid);
        },
          err => reject(err));
    });
  }

  loginEmail(email: string, pass: string) {
    return new Promise((resolve, reject) => {
      this.firebaseAuht.auth().signInWithEmailAndPassword(email, pass)
        .then(userData => {
          resolve(userData);
          this.loginserver(userData.user.uid);
          localStorage.setItem('uid', userData.user.uid);

          userData.user.getIdToken(true).then(token => {
            localStorage.setItem('token', token);
            // this.loginserver(token).subscribe((data: any) => console.log('retorno' + data), error => console.log(error.message));

          });
        },
          err => reject(err));
    });
  }

  private oAuthLogin(provider) {
    return firebase.auth().signInWithPopup(provider).then((credential) => {
      this.updateUserData(credential.user);
      // this.router.navigate(['/admin']);
    });
  }

  public updateUser(userData: User) {
    return this.firebaseAuht.auth().currentUser.updateProfile({
      displayName: userData.displayName,
      photoURL: userData.photoURL
    }).then(function () {
      // Update successful.
    }).catch(function (error) {
      // An error happened.
    });
  }

  private updateUserData(user) {

    const data: any = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      language: localStorage.getItem('language')
    };

    // this.updateUser(data);
    firebase.database().ref('users/' + user.uid).push(data);
    // return userRef.set(Object.assign(data), { merge: true });
  }

  private RecordUserData(user: User) {
    //console.log(user);

    //const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);

    const data: any = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      language: localStorage.getItem('language')
    };

    // this.updateUser(data);
    this.firebaseAuht.database().ref('users/' + user.uid).set(data);
    // return userRef.set(Object.assign(data), { merge: true });
  }

  logout() {
    return firebase.auth().signOut();
  }

  eliminar() {
    return firebase.auth().currentUser.delete();
  }

  resetPassword(email: string): Promise<any> {
    return this.firebaseAuht.auth().sendPasswordResetEmail(email);
  }

  changePassword(email: string, oldePassword: string, newPassword: string) {
    return this.firebaseAuht.auth().signInWithEmailAndPassword(email, oldePassword)
      .then(function (userCredential) {
        userCredential.user.updatePassword(newPassword);
      });
  }


  loginserver(googleUid) {

    const url = this.url.apibackdavid + '/Authentication/login';
    const LoginModel = {
      'googleUid': googleUid
    };
    return this.http.post(url, LoginModel);

  }

  GetUserSon(parentUser): Promise<User[]> {
    /* return this.afs.collection<User>('users', ref => ref.where('parentUser', '==', parentUser))
      .valueChanges(); */
    return new Promise((resolve, reject) => {
      this.firebaseAuht.database().ref('users').orderByChild('parentUser').equalTo(parentUser).once('value').then((snapshot) => {
        // var username = (snapshot.val() && snapshot.val() != null) || 'Anonymous';
        // console.log(snapshot.val());
        resolve(snapshot.val());
      })
        ,
        err => reject(err);
    });
  }
  // : Observable<User[]>
  GetUserProfile(uid): Observable<User[]> {
    /* firebase.database().ref('/users/' + uid).once('value').then(function(snapshot) {
       //var username = (snapshot.val() && snapshot.val().username) || 'Anonymous';
       this.userprofile.uid = snapshot.val().uid;
       this.userprofile.email = snapshot.val().email;
       this.userprofile.displayName = snapshot.val().displayName;
       this.userprofile.displayFirstName = snapshot.val().displayFirstName;
       this.userprofile.displayLastName = snapshot.val().displayLastName;
       this.userprofile.parentUser = snapshot.val().parentUser;
       this.userprofile.rol = snapshot.val().rol;
       this.userprofile.language = snapshot.val().language;
       return this.userprofile; 
     });*/
    //return this.userprofile;
    /*    return this.afs.collection<User>('users', ref => ref.where('uid', '==', uid))
         .valueChanges(); */
    return null;
  }

  registerUserBack(user: User, pass: string) {
    const data = {
      Email: user.email,
      FirstName: user.displayFirstName,
      LastName: user.displayLastName,
      GoogleUid: user.uid,
      ProfilePhotoSmallUrl: "",
      ProfilePhotoUrl: "",
      TimeZone: "",
      UserId: localStorage.getItem('uidCreat'),
      ParentUser: localStorage.getItem('uid'),
      language: localStorage.getItem('language'),
      PasswordHash: pass
    };
    //console.log(data);
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Access-Control-Allow-Origin': '*'
      })
    };

    const url = this.url.apibackdavid + '/api/user/create';

    return this.http.post(url, data);

  }
}
